<script>
/**
 * 产品目录（自 vancheen-b2b 的 ProductsView.vue 移植为 Vue 2 版本）
 * 系列筛选（Element UI 单选按钮组）+ 产品卡片栅格。
 * 筛选逻辑沿用原实现 —— 卡片全部保留在 DOM 中，仅切换显示（v-show）。
 * 支持 ?cat=auto / ?cat=building 直接定位到对应系列并滚动到 #catalog。
 *
 * 注意：Element UI 的 el-radio-button 用 label 作为选中值（Element Plus 用 value）。
 */
import NhShell from '../components/NhShell.vue'
import NhCtaBand from '../components/NhCtaBand.vue'
import NhPageHero from '../components/NhPageHero.vue'
import NhProductCard from '../components/NhProductCard.vue'
import { getSite } from '../nh-site-data'
import { t, setPageTitle } from '../nh-i18n'

export default {
  name: 'NhProductsPage',
  components: { NhShell, NhCtaBand, NhPageHero, NhProductCard },
  data() {
    return {
      filter: 'all'
    }
  },
  computed: {
    PRODUCT_FILTERS() {
      return getSite('PRODUCT_FILTERS')
    },
    PRODUCT_CATALOG() {
      return getSite('PRODUCT_CATALOG')
    },
    CTA_PRODUCTS() {
      const cta = getSite('CTA')
      return cta ? cta.products : { title: '', desc: '', actions: [] }
    }
  },
  watch: {
    '$route.query.cat'(cat) {
      if (!cat) return
      this.syncFromQuery(cat)
      this.scrollToCatalog()
    }
  },
  mounted() {
    setPageTitle('products')
    const cat = this.$route.query.cat
    this.syncFromQuery(cat)
    if (cat) this.scrollToCatalog()
  },
  methods: {
    t,
    syncFromQuery(cat) {
      const hit = this.PRODUCT_FILTERS.some(f => f.value === cat)
      if (cat && hit) this.filter = cat
    },
    scrollToCatalog() {
      setTimeout(() => {
        const el = document.getElementById('catalog')
        if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth' })
      }, 60)
    }
  }
}
</script>

<template>
  <NhShell>
    <NhPageHero
      :crumbs="[{ label: t('crumbs.home'), to: '/' }, { label: t('products.crumb') }]"
      :title="t('products.title')"
      :desc="t('products.desc')"
    />

    <!-- ===== 产品目录 ===== -->
    <section id="catalog" class="section">
      <div class="container">
        <el-radio-group v-model="filter" class="series-tabs">
          <el-radio-button
            v-for="item in PRODUCT_FILTERS"
            :key="item.value"
            :label="item.value"
          >{{ item.label }}</el-radio-button>
        </el-radio-group>

        <div class="product-grid">
          <NhProductCard
            v-for="(product, i) in PRODUCT_CATALOG"
            v-show="filter === 'all' || product.cat === filter"
            :key="product.name"
            :product="product"
            :delay="i % 4 || undefined"
          />
        </div>
      </div>
    </section>

    <!-- ===== CTA ===== -->
    <NhCtaBand
      :title="CTA_PRODUCTS.title"
      :desc="CTA_PRODUCTS.desc"
      :actions="CTA_PRODUCTS.actions"
    />
  </NhShell>
</template>
